import { useMemo } from "react";
import { FundRecommendationResponse } from "@rentablo/api/recommender";
import { useGetStandardIsinNames } from "@rentablo/api/apiv3";

export const useIsinNames = (
  recommendations?: FundRecommendationResponse[]
) => {
  const isins = recommendations
    ?.filter((recommendation) => recommendation.fund.isin)
    ?.map((recommendation) => recommendation.fund.isin);
  const { data: namesResponse } = useGetStandardIsinNames(
    {
      filterIsins: isins?.join(",")!,
    },
    {
      enabled: Boolean(isins?.length),
    }
  );

  const namesMap = useMemo(
    () =>
      namesResponse?.data?.reduce(
        (acc, name) => {
          if (name.attributes?.isin) {
            acc[name.attributes?.isin] = name.attributes?.name ?? "";
          }
          return acc;
        },
        {} as Record<string, string>
      ),
    [namesResponse]
  );

  const recommendationsWithNames = useMemo(
    () =>
      recommendations?.map((recommendation) => ({
        ...recommendation,
        fund: {
          ...recommendation.fund,
          name:
            namesMap?.[recommendation.fund.isin] ?? recommendation.fund.name,
        },
      })),
    [recommendations, namesMap]
  );

  return recommendationsWithNames;
};
